<template>
  <div>
    <Modal v-model="registerRole" :mask-closable="false" class="registerClass" footer-hide title="产品注册"
           @on-visible-change='closeModal'>
      <Form ref="registerForm" :label-width="100" :model="registerCustom" :rules="registerRules" inline>
        <Divider orientation="left" plain>生成注册地址</Divider>
        <Form-item label="用户名称：" prop='consumerName'>
          <Input
            v-model="registerCustom.consumerName"
            clearable
            placeholder="请输入"
            style="width: 300px"
          ></Input>
        </Form-item>
        <Form-item label="项目名称：" prop='projectName'>
          <Input
            v-model="registerCustom.projectName"
            clearable
            placeholder="请输入"
            style="width: 300px"
          ></Input>
        </Form-item>
        <br>
        <Form-item label="联系电话：" prop='consumerTel'>
          <Input
            v-model="registerCustom.consumerTel"
            clearable
            placeholder="请输入"
            style="width: 300px"
          ></Input>
        </Form-item>
        <Form-item label="联系邮箱：" prop='email'>
          <Input
            v-model="registerCustom.email"
            clearable
            placeholder="请输入"
            style="width: 300px"
          ></Input>
        </Form-item>
        <br>
        <div style="text-align:right">
          <Button :loading="createLoading" type="primary" @click="commitModal('registerForm')">生成注册申请</Button>
        </div>
        <br>
        <Divider orientation="left" plain>导入许可文件</Divider>
        <p style="text-indent:24px">
          本次许可证为免费1年，过期后需要自行购买！导入的产品许可需将注册申请文件进行处理，若申请产品试用可联系售前咨询。</p>
        <div style="text-align:right;margin-top:10px">
          <Upload
            ref="upload"
            :action="handleUrl"
            :format="['lic']"
            :headers='upLoadToken'
            :on-error="handleError"
            :on-success="handleSuccess"
            :show-upload-list="false"
            style="display:inline-block"
          >
            <Button style="margin-left:8px" type="primary">导入许可文件</Button>
          </Upload>
        </div>
      </Form>
    </Modal>
  </div>
</template>

<script>
export default {
  name: 'registerModal',
  props: {
    createLoading: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
    return {
      registerRole: true,
      registerCustom: {
        consumerName: '',
        projectName: '',
        consumerTel: '',
        email: ''
      },
      registerRules: {
        consumerName: [{required: true, message: '用户名称不能为空', trigger: 'blur'}],
        projectName: [{required: true, message: '项目名称不能为空', trigger: 'blur'}],
        consumerTel: [{required: true, message: '联系电话不能为空', trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              let reg = /[\u4E00-\u9FFF]+/g
              if (!reg.test(value)) {
                callback()
              } else {
                callback(new Error('请输入正确手机号码，不能包含中文。'))
              }
            },
            trigger: 'blur'
          },
          {
            validator: (rule, value, callback) => {
              let telnum = /^1d{10}$/
              if (telnum.test(value)) {
                callback()
              } else {
                callback(new Error('请输入正确手机号码，共11位'))
              }
            },
            trigger: 'blur'
          }],
        email: [{required: true, message: '联系邮箱不能为空', trigger: 'blur'}]
      },
      handleUrl: this.$getImg + 'system/license/install', // 导入连接
      upLoadToken: {Authorization: 'Bearer ' + localStorage.getToken}
    }
  },
  mounted() {

  },
  methods: {
    // 导入文件格式要求
    handleFormatError() {
      this.$Message.warning('文件格式不正确，请上传.lic文件。')
    },
    // 导入成功
    handleSuccess(res) {
      if (res.success === false) {
        this.$Message.error(res.msg)
        this.registerRole = true
      } else {
        this.registerRole = false
        this.$Message.success('成功')
      }
    },
    // 导入失败
    handleError(error, file) {
      this.$Message.error(file.msg)
    },
    // 关闭弹窗事件
    closeModal(val) {
      if (!val) {
        this.$emit('closeModal')
      }
    },
    // 确认按钮
    commitModal(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          let newObject = JSON.parse(JSON.stringify(this.registerCustom))
          this.$emit('commitModal', newObject)
          this.$refs[name].resetFields()
        }
      })
    }
  }
}
</script>

<style lang='less' scoped>
.registerClass {
  /deep/ .ivu-modal {
    width: 1000px !important;
  }
}
</style>
